import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSubCategoryProducts } from '../../api/subCategoryProductApi';

export const getProducts = createAsyncThunk('product/getProducts', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchSubCategoryProducts(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const subCategoryProductSlice = createSlice({
  name: 'subCategoryProduct',
  initialState: {
    products: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default subCategoryProductSlice.reducer;
